module.exports = __webpack_public_path__ + "9dd0d2a9b37a259645f06824809c10aa.png";